import { Contact } from '@/shared/types/api'

const CONTACT_URI_PREFIX = 'data-contact-uri="'
const CONTACT_URI_PREFIX_LENGTH = 18

export function parseMention (messageText: string, contacts: Map<string, Contact>): string[] {
  const result = new Set<string>()
  let i = messageText.indexOf(CONTACT_URI_PREFIX)
  while (i > -1 && i < messageText.length) {
    i = i + CONTACT_URI_PREFIX_LENGTH

    const finalPosition = messageText.indexOf('"', i)
    const contactUri = messageText.slice(i, finalPosition)

    if (contactUri === 'All') {
      for (const contact of contacts.values()) {
        result.add(contact.imLogin)
      }
    } else if (contactUri) {
      result.add(contactUri)
    }

    i = messageText.indexOf(CONTACT_URI_PREFIX, finalPosition)
  }
  return Array.from(result)
}
